import { Http, Headers, URLSearchParams, RequestOptions } from "@angular/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService } from '../core/cache.service';
import { ApiService } from '../core/api.service';
import { Mappings } from '../../shared/mapping';
import { HttpParam } from "./../../models/core/http-param";

@Injectable()
export class CheckIfExistService {
        constructor
                (
                public _api: ApiService,
                public _cache: CacheService,
                private mappings: Mappings
                ) { }

        //for sending of checking type, because we are using same method on server side for all checking
        public readonly emailType: string = "email";
        public readonly partitaIvaType: string = "partitaIva";
        public readonly codiceFiscaleType: string = "codiceFiscale";

        checkIfEmailExistsInDb(value: string) {
                let url = this.mappings.Web_Api_Check_If_Param_Exists_In_Db.replace('{type}', this.emailType).replace('{value}', value);

                return this._api.get(url);
        }

        checkIfPartitaIvaExistsInDb(value: string) {
                let url = this.mappings.Web_Api_Check_If_Param_Exists_In_Db.replace('{type}', this.partitaIvaType).replace('{value}', value);

                return this._api.get(url);
        }

        checkIfCodiceFiscaleExistsInDb(value: string) {
                let url = this.mappings.Web_Api_Check_If_Param_Exists_In_Db.replace('{type}', this.codiceFiscaleType).replace('{value}', value);

                return this._api.get(url);
        }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/check-existence.service.ts